import { render, staticRenderFns } from "./MyImg.vue?vue&type=template&id=2c4f5757&scoped=true"
import script from "./MyImg.vue?vue&type=script&lang=js"
export * from "./MyImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4f5757",
  null
  
)

export default component.exports